// Costanti centralizzate per i metodi di pagamento
// Usate sia nella pagina Pagamenti & Provvigioni globale che nel Centro Pagamenti del Bene

// Metodi per INCASSO (entrate)
export const PAYMENT_METHODS_INCASSO = [
  { value: 'contanti_drop', label: 'Contanti - Drop' },
  { value: 'pos_drop', label: 'POS - Drop' },
  { value: 'misto_drop', label: 'Misto - Drop' },
  { value: 'bonifico_fornitore', label: 'Bonifico al Fornitore' },
  { value: 'bonifico', label: 'Bonifico' },
  { value: 'da_incassare', label: 'Da Incassare' },
];

// Metodi per USCITA (pagamenti a fornitori)
export const PAYMENT_METHODS_USCITA = [
  { value: 'bonifico_posta', label: 'Bonifico - Posta' },
  { value: 'bonifico_drop', label: 'Bonifico - Drop' },
  { value: 'bonifico_cliente', label: 'Bonifico dal Cliente' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'contanti', label: 'Contanti' },
  { value: 'da_saldare', label: 'Da Saldare' },
];

// Helper per ottenere la label di un metodo
export const getPaymentMethodLabel = (value, type = 'incasso') => {
  const methods = type === 'incasso' ? PAYMENT_METHODS_INCASSO : PAYMENT_METHODS_USCITA;
  const method = methods.find(m => m.value === value);
  return method?.label || value;
};
